"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_STORE_DISPLAY_WITH_STORE_DATA = void 0;
var client_1 = require("@apollo/client");
var DisplayWithStoreDataFragment_1 = require("../fragments/DisplayWithStoreDataFragment");
exports.GET_STORE_DISPLAY_WITH_STORE_DATA = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetDisplayWithStoreData($displayId: ID!) {\n    display(displayId: $displayId) {\n      ...DisplayWithStoreData\n    }\n  }\n  ", "\n"], ["\n  query GetDisplayWithStoreData($displayId: ID!) {\n    display(displayId: $displayId) {\n      ...DisplayWithStoreData\n    }\n  }\n  ", "\n"])), DisplayWithStoreDataFragment_1.DISPLAY_WITH_STORE_DATA_FRAGMENT);
var templateObject_1;
